'use client';

import { Suspense, useRef } from 'react';
import { Await } from 'react-router';
import { Region } from '@/components/region';
import type { ContentSlotPageWithComponentData } from '@/extensions/snk/lib/content-slot-page';
import { FOOTER_LINK_REGION_IDS } from '@/features/global-footer/constants';

type LinkColumnsProps = {
    globalContentSlots: Promise<ContentSlotPageWithComponentData>;
};

export const LinkColumns = ({ globalContentSlots }: LinkColumnsProps) => {
    const pageRef = useRef<Promise<ContentSlotPageWithComponentData> | undefined>(undefined);
    if (!pageRef.current) {
        pageRef.current = globalContentSlots;
    }

    const page = pageRef.current;

    return (
        <Suspense fallback={null}>
            <Await resolve={page} errorElement={null}>
                {(resolved) => (
                    <div
                        data-slot="global-footer-link-columns"
                        className="grid grid-cols-1 lg:grid-cols-5 lg:pt-8 gap-x-4">
                        {FOOTER_LINK_REGION_IDS.map((regionId) => (
                            <div key={regionId}>
                                <Region
                                    page={resolved}
                                    regionId={regionId}
                                    fallbackElement={null}
                                    errorElement={null}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </Await>
        </Suspense>
    );
};
